module.exports = __webpack_public_path__ + "static/media/hero-image-2.9616730d.png";